<template>
  <div :style="style" :ref="'lavContainer' + id"></div>
</template>

<script>
import lottie from "lottie-web";
export default {
  name: "LottieAnimation",
  emits: ["animCreated"],
  props: {
    id: Number,
    options: {
      type: Object,
      required: true,
    },
    height: Number,
    width: Number,
  },
  data() {
    return {
      style: {
        width: this.width ? `${this.width}px` : "100%",
        height: this.height ? `${this.height}px` : "100%",
        overflow: "hidden",
      },
    };
  },
  // Keep style in sync when width/height props change (e.g. responsive avatar).
  watch: {
    width(next) {
      this.style.width = next ? `${next}px` : "100%";
    },
    height(next) {
      this.style.height = next ? `${next}px` : "100%";
    },
  },
  mounted() {
    this.anim = lottie.loadAnimation({
      container: this.$refs["lavContainer" + this.id],
      renderer: "svg",
      loop: this.options.loop !== false,
      autoplay: this.options.autoplay ? this.options.autoplay : false,
      animationData: this.options.animationData,
      path: this.options.path,
      rendererSettings: this.options.rendererSettings,
    });
    this.$emit("animCreated", this.anim);
  },
  beforeUnmount() {
    if (this.anim) this.anim.destroy();
  },
};
</script>
